export const NUTRITION_AI = "Nutrition AI";
export const NUTRITION_AI_SLUG = "nutrition-ai";
export const NUTRITION_AI_LOW_SLUG = "nutrition-ai-low";
export const NUTRITION_AI_MID_SLUG = "nutrition-ai-mid";
export const NUTRITION_AI_HIGH_SLUG = "nutrition-ai-high";

export const NUTRITION_API = "Nutrition API";
export const NUTRITION_API_SLUG = "nutrition-api";
export const NUTRITION_API_LOW_SLUG = "nutrition-api-low";
export const NUTRITION_API_MID_SLUG = "nutrition-api-mid";

export const NUTRITION_ADVISOR = "Nutrition Advisor";
export const NUTRITION_ADVISOR_SLUG = "nutrition-advisor";
export const NUTRITION_ADVISOR_LOW_SLUG = "nutrition-advisor-low";
export const NUTRITION_ADVISOR_MID_SLUG = "nutrition-advisor-mid";

export const REMODEL_AI = "Remodel AI";
export const REMODEL_AI_SLUG = "remodel-ai";
export const REMODEL_AI_LOW_SLUG = "remodel-ai-low";
export const REMODEL_AI_MID_SLUG = "remodel-ai-mid";

export const VR_SHOWROOM = "VR Showroom";
export const VR_SHOWROOM_SLUG = "vr-showroom";
export const VR_SHOWROOM_LOW_SLUG = "vr-showroom-low";

export const MOBILE_AI = "Mobile AI";
export const MOBILE_AI_SLUG = "mobile-ai";
export const MOBILE_AI_FREE_SLUG = "mobile-ai-free";
export const MOBILE_AI_PRO_SLUG = "mobile-ai-pro";

export const PAINTS_AI = "Paints AI";

export const PASSIO_HUB = "Unified";
export const PASSIO_HUB_SLUG = "unified";

// Tiered AI Hub - New tiered subscription model
export const AI_HUB = "AI Hub";
export const AI_HUB_SLUG = "ai-hub";
export const AI_HUB_TRIAL_SLUG = "ai-hub-trial";
export const AI_HUB_MID_SLUG = "ai-hub-mid";
export const AI_HUB_HIGH_SLUG = "ai-hub-high";

// Nutrition AI Platform
export const NUTRITION_PLATFORM = "Nutrition Platform";
export const NUTRITION_PLATFORM_SLUG = "nutrition-platform";
export const NUTRITION_PLATFORM_STARTER_SLUG = "nutrition-platform-starter";
export const NUTRITION_PLATFORM_GROWTH_SLUG = "nutrition-platform-growth";
export const NUTRITION_PLATFORM_PRO_SLUG = "nutrition-platform-pro";

const productNameSlugLookup: { [slug: string]: string } = {
  [NUTRITION_API_LOW_SLUG]: NUTRITION_API_SLUG,
  [NUTRITION_API_MID_SLUG]: NUTRITION_API_SLUG,
  [NUTRITION_ADVISOR_LOW_SLUG]: NUTRITION_ADVISOR_SLUG,
  [NUTRITION_ADVISOR_MID_SLUG]: NUTRITION_ADVISOR_SLUG,
  [REMODEL_AI_LOW_SLUG]: REMODEL_AI_SLUG,
  [REMODEL_AI_MID_SLUG]: REMODEL_AI_SLUG,
  [VR_SHOWROOM_LOW_SLUG]: VR_SHOWROOM_SLUG,
  [NUTRITION_AI_LOW_SLUG]: NUTRITION_AI_SLUG,
  [NUTRITION_AI_MID_SLUG]: NUTRITION_AI_SLUG,
  [NUTRITION_AI_HIGH_SLUG]: NUTRITION_AI_SLUG,
  [MOBILE_AI_FREE_SLUG]: MOBILE_AI_SLUG,
  [MOBILE_AI_PRO_SLUG]: MOBILE_AI_SLUG,
  [MOBILE_AI_SLUG]: MOBILE_AI_SLUG,
  [PASSIO_HUB_SLUG]: PASSIO_HUB,
  // Tiered AI Hub
  [AI_HUB_SLUG]: AI_HUB_SLUG,
  [AI_HUB_TRIAL_SLUG]: AI_HUB_SLUG,
  [AI_HUB_MID_SLUG]: AI_HUB_SLUG,
  [AI_HUB_HIGH_SLUG]: AI_HUB_SLUG,
  // Nutrition AI Platform
  [NUTRITION_PLATFORM_SLUG]: NUTRITION_PLATFORM_SLUG,
  [NUTRITION_PLATFORM_STARTER_SLUG]: NUTRITION_PLATFORM_SLUG,
  [NUTRITION_PLATFORM_GROWTH_SLUG]: NUTRITION_PLATFORM_SLUG,
  [NUTRITION_PLATFORM_PRO_SLUG]: NUTRITION_PLATFORM_SLUG,
};

const productSlugLookup: { [slug: string]: string } = {
  [NUTRITION_API_LOW_SLUG]: NUTRITION_API,
  [NUTRITION_API_MID_SLUG]: NUTRITION_API,
  [NUTRITION_ADVISOR_LOW_SLUG]: NUTRITION_ADVISOR,
  [NUTRITION_ADVISOR_MID_SLUG]: NUTRITION_ADVISOR,
  [REMODEL_AI_LOW_SLUG]: REMODEL_AI,
  [REMODEL_AI_MID_SLUG]: REMODEL_AI,
  [VR_SHOWROOM_LOW_SLUG]: VR_SHOWROOM,
  [NUTRITION_AI_LOW_SLUG]: NUTRITION_AI,
  [NUTRITION_AI_MID_SLUG]: NUTRITION_AI,
  [NUTRITION_AI_HIGH_SLUG]: NUTRITION_AI,
  [MOBILE_AI_FREE_SLUG]: MOBILE_AI,
  [MOBILE_AI_PRO_SLUG]: MOBILE_AI,
  [MOBILE_AI_SLUG]: MOBILE_AI,
  [PASSIO_HUB_SLUG]: PASSIO_HUB,
  // Tiered AI Hub
  [AI_HUB_SLUG]: AI_HUB,
  [AI_HUB_TRIAL_SLUG]: AI_HUB,
  [AI_HUB_MID_SLUG]: AI_HUB,
  [AI_HUB_HIGH_SLUG]: AI_HUB,
  // Nutrition AI Platform
  [NUTRITION_PLATFORM_SLUG]: NUTRITION_PLATFORM,
  [NUTRITION_PLATFORM_STARTER_SLUG]: NUTRITION_PLATFORM,
  [NUTRITION_PLATFORM_GROWTH_SLUG]: NUTRITION_PLATFORM,
  [NUTRITION_PLATFORM_PRO_SLUG]: NUTRITION_PLATFORM,
};

const isValidProduct = (productSlug: string | null): boolean => {
  switch (productSlug) {
    case NUTRITION_AI_SLUG:
      return true;
    case NUTRITION_AI_LOW_SLUG:
      return true;
    case NUTRITION_AI_MID_SLUG:
      return true;
    case NUTRITION_AI_HIGH_SLUG:
      return true;
    case NUTRITION_API_SLUG:
      return true;
    case NUTRITION_API_LOW_SLUG:
      return true;
    case NUTRITION_API_MID_SLUG:
      return true;
    case NUTRITION_ADVISOR_SLUG:
      return true;
    case NUTRITION_ADVISOR_LOW_SLUG:
      return true;
    case NUTRITION_ADVISOR_MID_SLUG:
      return true;
    case REMODEL_AI_SLUG:
      return true;
    case REMODEL_AI_LOW_SLUG:
      return true;
    case REMODEL_AI_MID_SLUG:
      return true;
    case VR_SHOWROOM_LOW_SLUG:
      return true;
    case VR_SHOWROOM_SLUG:
      return true;
    case MOBILE_AI_SLUG:
      return true;
    case MOBILE_AI_FREE_SLUG:
      return true;
    case MOBILE_AI_PRO_SLUG:
      return true;
    case PASSIO_HUB_SLUG:
      return true;
    // Tiered AI Hub
    case AI_HUB_SLUG:
      return true;
    case AI_HUB_TRIAL_SLUG:
      return true;
    case AI_HUB_MID_SLUG:
      return true;
    case AI_HUB_HIGH_SLUG:
      return true;
    // Nutrition AI Platform
    case NUTRITION_PLATFORM_SLUG:
      return true;
    case NUTRITION_PLATFORM_STARTER_SLUG:
      return true;
    case NUTRITION_PLATFORM_GROWTH_SLUG:
      return true;
    case NUTRITION_PLATFORM_PRO_SLUG:
      return true;
  }

  return false;
};

const productNameFromSlug = (slug: string | null): string => {
  if (!slug) {
    return "";
  }
  return productSlugLookup[slug];
};

const productNameSlugFromProductPlanSlug = (slug: string | null): string => {
  if (!slug) {
    return "";
  }
  const n = productNameSlugLookup[slug];
  if (n === PASSIO_HUB_SLUG) {
    return "nutrition-hub";
  }
  // Handle tiered AI Hub - all tier slugs map to ai-hub
  if (n === AI_HUB_SLUG) {
    return AI_HUB_SLUG;
  }
  // Handle Nutrition AI Platform - all tier slugs map to nutrition-platform
  if (n === NUTRITION_PLATFORM_SLUG) {
    return NUTRITION_PLATFORM_SLUG;
  }
  if (n === undefined) {
    return slug;
  }
  return n;
};

const uniqueEventId = (): string => {
  return `${Math.random().toString(36).substring(2, 15)}`;
};

const eventFromProductPlanSlug = (
  event: string,
  slug: string | null
): string => {
  if (!slug) {
    return event;
  }
  return `${event}_${slug.replaceAll("-", "_")}`;
};

export {
  isValidProduct,
  productNameFromSlug,
  productNameSlugFromProductPlanSlug,
  eventFromProductPlanSlug,
  uniqueEventId,
};
